module.exports = __webpack_public_path__ + "img/1.894b9014.jpg";